<template>
  <Dialog :open="props.show" @update:open="onClose">
    <DialogContent class="sm:max-w-[500px]">
      <RequestTab v-if="currentTab === 'create'" :order="order" @next="createDirectPayment" />
      <SuccessTab v-if="currentTab === 'success'" @close="onClose" />
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { ref } from 'vue';
import type { ModelOrderResponse } from '@layup/api-sdk';
import RequestTab from './tabs/DisputeResponseRequestTab.vue';
import SuccessTab from './tabs/DisputeResponseSuccessTab.vue';

const emit = defineEmits(['update:show']);

const props = defineProps<{
  show: boolean;
  order: ModelOrderResponse;
}>();

const currentTab = ref<'create' | 'success'>('create');

const createDirectPayment = () => {
  currentTab.value = 'success';
};

const onClose = () => {
  emit('update:show');
  currentTab.value = 'create';
};
</script>
